import React, { ReactNode, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useLocation } from 'react-router-dom';

import Container from 'components/Container';

import { Topbar, Sidebar, Footer } from './components';

import pages from '../navigation';

interface MainProps {
  children?: ReactNode;
  colorInvert?: boolean;
  bgcolor?: string;
}

const Main = ({
  children,
  colorInvert = false,
  bgcolor = 'transparent',
}: MainProps) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const location = useLocation();
  const hasOverlappingComponent = location.pathname === '/'; // perhaps we can use navigation.js to configure which sides have "overlapping component"

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  return (
    <Box>
      <AppBar
        position={'sticky'}
        sx={{
          top: 0,
          backgroundColor: true ? theme.palette.background.paper : bgcolor,
        }}
        elevation={true ? 1 : 0}
      >
        <Container paddingY={3}>
          <Topbar
            onSidebarOpen={handleSidebarOpen}
            pages={pages}
            colorInvert={!true && hasOverlappingComponent}
          />
        </Container>
      </AppBar>
      <Sidebar
        onClose={handleSidebarClose}
        open={open}
        variant="temporary"
        pages={pages}
      />
      <main>{children}</main>
      <Box sx={{ boxShadow: '0px -1px 14px 0px #0000001A inset' }}>
        <Container paddingY={'2vh'} sx={{ paddingTop: '24px' }}>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Main;
